module.exports = __webpack_public_path__ + "static/media/Adv X IM.8adb1b3d.png";